import React from 'react'
import { FormSection } from 'redux-form'
import EyefinityFields from './EyefinityFields'
import { humanize } from '../../../../../../../../../itrust_common/components/HelperFunctions'
import ContactLensBrandField from './ContactLensBrandField'
import { shouldShowClaimSection } from './eyefinityServiceSections'
import { shouldDisableEyefinityField } from './eyefinityFieldDisableRules'

const getValueByPath = (values, path) => (
  path?.split('.').reduce((acc, key) => acc?.[key], values)
)

const findValueByFieldName = (values, fieldName) => {
  if (!values || !fieldName) return undefined

  const normalizedFieldName = fieldName.replace(/\?$/, '')
  const matchingKey = Object.keys(values).find(key => key === fieldName || key === normalizedFieldName)

  if (matchingKey) {
    return values[matchingKey]
  }

  return Object.values(values).reduce((foundValue, value) => {
    if (foundValue !== undefined || !value || typeof value !== 'object') return foundValue

    return findValueByFieldName(value, fieldName)
  }, undefined)
}

export default function EyefinitySectionFields(props) {
  const { title, fields = [], formValues, sectionName, showRequiredMark = false } = props

  if (!shouldShowClaimSection(sectionName, formValues?.eligibility?.data)) return null

  const shouldShowField = (field) => {
    if (!field.show_when) return true

    const sectionValue = getValueByPath(formValues?.[sectionName], field.show_when.field)
    const showWhenValue = sectionValue ?? findValueByFieldName(formValues, field.show_when.field)

    if (field.show_when.value_in) {
      const valueIn = Array.isArray(field.show_when.value_in) ? field.show_when.value_in : [field.show_when.value_in]
      return valueIn.includes(showWhenValue)
    }

    return showWhenValue === field.show_when.value
  }

  const isFieldDisabled = (fieldLabel) => (
    shouldDisableEyefinityField({ fieldLabel, sectionName, formValues })
  )

  const renderField = (field) => {
    const colClass = field.type === 'radio' ? 'col-4 mb-3' : 'col-4 mb-3'
    if (!shouldShowField(field)) return null
    const fieldConfig = field.label === 'insured_policy_group_or_feca_number'
      ? { ...field, type: 'text' }
      : field
    const manufacturerValue = formValues?.contact_lens?.manufacturer
    if (field.type === 'section') {
      return (
        <div key={field.label} className="col-12">
          <h5 className="mt-4 mb-3">
            {humanize(field.label)}
          </h5>

          <div className="row">
            {field.options?.map(childField => (
              <div key={childField.label} className="col-md-4 mb-3">
                <EyefinityFields
                  field={childField}
                  disabled={isFieldDisabled(childField.label)}
                  showRequiredMark={showRequiredMark}
                />
              </div>
            ))}
          </div>
        </div>
      )
    }
    if (
      sectionName === 'contact_lens' &&
      field.label === 'brand'
    ) {
      return (
        <div key={field.label} className="col-md-4 mb-3">
          <ContactLensBrandField
            brandField={field}
            manufacturerValue={manufacturerValue}
          />
        </div>
      )
    }

    return (
      <div key={field.label} className={colClass}>
        <EyefinityFields field={fieldConfig} disabled={isFieldDisabled(field.label)} showRequiredMark={showRequiredMark} />
      </div>
    )
  }

  if (!fields.length) return null

  return (
    <div className="mb-5 bg-white p-5">
      <h4 className="mb-3 text-capitalize">
        {title || humanize(sectionName)}
      </h4>

      <FormSection name={sectionName}>
        <div className="row">
          {fields.map(field => renderField(field))}
        </div>
      </FormSection>
    </div>
  )
}
